import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";
import { NewsApi } from "@/zh-website/src/views/Content/api/newsApi";

export class NewsService extends BaseAbstractService {
  static getNewsList(params) {
    return NewsApi.getNewsList(this.request, params);
  }
  static getNewsDetail(params) {
    return NewsApi.getNewsDetail(this.request, params);
  }
  static getNewsCarousel(params) {
    return NewsApi.getNewsCarousel(this.request, params);
  }
  static getNewsNumber() {
    return NewsApi.getNewsNumber(this.request);
  }
  static getReportList(params) {
    return NewsApi.getReportList(this.request,params);
  }
  static getReportsNumber() {
    return NewsApi.getReportsNumber(this.request);
  }
  static getReportDetail(params) {
    return NewsApi.getReportDetail(this.request,params);
  }
}
NewsService.setRequest(RequestService);
